import { isLinkPrefixedWithBaseUrl } from 'owa-sharepoint-link-detector';
import { ONE_DRIVE_CONUSMER_BASE_URLS } from './constants';

export function isOneDriveConsumerLink(url: string): boolean {
    return isLinkPrefixedWithBaseUrl(url, ONE_DRIVE_CONUSMER_BASE_URLS);
}
